var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"year-aggregated-chart",attrs:{"options":_vm.chartOptions,"auto-resize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }